import { alertMessages } from "src/constants";
import { ROUTE_PATHS } from "src/routes";
import { getAccessTokenCookie } from "src/shared/Login/AuthProvider";
import moment from 'moment-timezone'
export const regex4decimals = /^-?\d*\.?\d{0,4}$/;
export const regex2decimals = /^-?\d*\.?\d{0,2}$/;

export const mergeArrays=(arr1:any, arr2:any, key:string) =>{
    const map = new Map();

  // Helper function to merge keys while skipping null/undefined
  const mergeObjectsCleanly = (target, source) => {
    for (const key in source) {
      if (source[key] !== null && source[key] !== undefined) {
        target[key] = source[key];
      }
    }
    return target;
  };

  // Process both arrays sequentially
  [...arr1, ...arr2].forEach(obj => {
    const keyValue = obj[key];
    
    if (map.has(keyValue)) {
      // Merge with existing record, keeping non-null values
      mergeObjectsCleanly(map.get(keyValue), obj);
    } else {
      // Create a clean shallow copy of the object
      map.set(keyValue, mergeObjectsCleanly({}, obj));
    }
  });

  return Array.from(map.values());
}

export const findMaxByKey=(arr:any[], key: string)=> {
    if (!Array.isArray(arr) || arr.length === 0) {
        return null; // Handle empty or invalid input
    }

    // Ensure the key exists and values are comparable
    return arr.reduce((maxObj, currentObj) => {
        if (currentObj && typeof currentObj[key] !== "undefined") {
            if (!maxObj || currentObj[key] > maxObj[key]) {
                return currentObj;
            }
        }
        return Number(maxObj);
    }, null);
}

export const findMinByKey=(arr:any[], key: string)=> {
    if (!Array.isArray(arr) || arr.length === 0) {
        return null; // Handle empty or invalid array
    }

    let minValue = Infinity;

    for (const obj of arr) {
        if (obj && typeof obj[key] === "number") {
            if (obj[key] < minValue) {
                minValue = obj[key];
            }
        }
    }

    return minValue === Infinity ? null : Number(minValue);
}

export const removeByIndexesInPlace=(arr:any[], indexes: number[])=> {
    if (!Array.isArray(arr) || !Array.isArray(indexes)) {
        throw new TypeError("Both arguments must be arrays.");
    }

    // Sort indexes in descending order to avoid shifting issues
    const sortedIndexes = [...new Set(indexes)]
        .filter(i => Number.isInteger(i) && i >= 0 && i < arr.length)
        .sort((a, b) => b - a);

    for (const idx of sortedIndexes) {
        arr.splice(idx, 1);
    }
    return arr
}

export const getMinFromSelectedFields = (objArray: any[], selectedKeys: string[], val: number)=>{
  const minimum = Math.min(
    ...objArray.flatMap(obj => selectedKeys.map(key=>obj[key]).filter(value=>value!== undefined && value!==null))
  )
  return minimum-val < 0? 0: minimum-val
}

export const getMaxFromSelectedFields = (objArray: any[], selectedKeys: string[])=>{
  const maximum = Math.min(
    ...objArray.flatMap(obj => selectedKeys.map(key=>obj[key]).filter(value=>value!== undefined && value!==null))
  )
  return maximum+5?0: maximum+5
}

export const buildPath = (params: any, history: any, stationId?:any)=>{
  //For weather "?Weather/radio/element/zoom/basemap/minElevation/maxElevation/windDir/windSpeed"
  //For FieldSample "?FieldSample/category/fuel/zoom/basemap/minElevation/maxElevation/method/subCat"
    if(stationId){
      const path = '?'+params.dataType +'/'+ params.radio +'/'+ params.element +'/'+ params.zoom +'/'+ params.basemap +'/'+ params.minElevation +'/'+ params.maxElevation +'/'+ params.windOrMethod +'/'+ params.windOrSub + '/'+ stationId
      history.push({pathname: `${ROUTE_PATHS.home}`, search: path});
      const pathforSession = '?'+params.dataType +'/'+ params.radio +'/'+ params.element +'/'+ params.zoom +'/'+ params.basemap +'/'+ params.minElevation +'/'+ params.maxElevation +'/'+ params.windOrMethod +'/'+ params.windOrSub;
      sessionStorage.setItem('path', pathforSession);
    }
    else{
      const path = '?'+params.dataType +'/'+ params.radio +'/'+ params.element +'/'+ params.zoom +'/'+ params.basemap +'/'+ params.minElevation +'/'+ params.maxElevation +'/'+ params.windOrMethod +'/'+ params.windOrSub;
      history.push({pathname: `${ROUTE_PATHS.home}`, search: path});
      sessionStorage.setItem('path', path);
    }
  
}
export function getTextColor(backgroundColor){
  let rgb = backgroundColor.toRgb();
  let luminance = (299* rgb[0] + 587 * rgb[1] + 114 * rgb[2])/1000;
  return luminance >=120.1? "black": "white"

};
export const backgroundColor = (data: number, colors: any[])=>{
  let colorToReturn:string=''
  let luminance:number=0;
  if(data === -2000 || data===-500000 || data===null){
    return {bg: 'white', text:'black'}
  }
  else{
    colors.forEach((color)=>{
      if(data>=color.minValue && data<= color.maxValue){
        colorToReturn= `rgb(${color.rgb[0]},${color.rgb[1]},${color.rgb[2]})`;
        luminance = (299 * color.rgb[0] + 587 * color.rgb[1] + 144 * color.rgb[2])/1000;
      }
    })
    if(luminance>=120.1){
      return {bg: colorToReturn, text: "black"}
    }
    else{
      return {bg: colorToReturn, text: "white"}
  
    }
  }

};
export const SFColors = (sfValue:string)=>{
  if(sfValue==='N'){
    return{bg: 'rgb(192,68,0)', text: 'white'}
  }
  else if(sfValue==='Y'){
    return{bg: 'rgb(41,62,155)', text: 'white'}
  }
  else{
    return{bg: 'white', text: 'black'}
  }
}
export const generateUUID = (): string =>{
  const crypto = window.crypto || window.Crypto;
  let array = new Uint32Array(1);
  crypto.getRandomValues(array); // Compliant for security-sensitive use cases
  const FileId = array[0];
  return FileId.toString();
}

export const windDirectionChange = (wind_direction:number)=>{
  if(wind_direction>=0 && wind_direction<=180){
      return (wind_direction+ 180)
  }
  else{
      return (wind_direction-180)
  }
}

export const currentDate = (): string =>{
  const now = new Date();
  return `${now.getMonth()+1}/${now.getDate()}/${now.getFullYear()}`;
}

export const formatDate =(dateString: string): string =>{
  if(dateString[11].includes('0')){
    return dateString[5]+dateString[6]+"-"+ dateString[8]+dateString[9]+"-"+dateString[2]+dateString[3]+"/"+dateString[12]+ dateString[13]+dateString[14]+dateString[15];
  }
  else{
    return dateString[5]+dateString[6]+"-"+ dateString[8]+dateString[9]+"-"+dateString[2]+dateString[3]+"/"+dateString[11]+dateString[12]+ dateString[13]+dateString[14]+dateString[15];
  }
}

export const toMonthDayYearFormat = (dateString: string): string => {
  let dateChunks = dateString.split("-");
  const month = String(dateChunks[1]).padStart(2, '0'); // Months are 0-indexed
  const day = String(dateChunks[2]).padStart(2, '0');
  const year = String(dateChunks[0]).slice(-2); // Get last two digits of the year
  return `${month}/${day}/${year}`;
} 

export const formatMinute =(timeString: string): string =>{
  return timeString[14]+timeString[15];
}

export const formatDateAdd=(dateString:string, index:number): string=>{
  let lastDigit=''
  if(index+8<=9){
    lastDigit='0'+(8+index).toString();
  }
  else{
    lastDigit=(8+index).toString()
  }
  return dateString[5]  + dateString[8] +"/"+lastDigit;
}


 /**  Character names as per ASCII table
  * https://www.ibm.com/docs/en/sdse/6.4.0?topic=configuration-ascii-characters-from-33-126 
 */
export enum  ValidCharacters {
  Alpha = 'alpha',
  Numeric = 'numeric',
  Space = ' ',
  TextField = 'textfield',
  Period = '.',
  Hyphen = '-',
  NumberSign = '#',
  Comma = ',',
  PercentSign = '%'
}

function toAlpha(){
  const alpha = Array.from(new Array(26)).map((e, i) => i + 65);
  const alphabet = alpha.map((x) => {
    let character = String.fromCodePoint(x);
    return character + character.toLowerCase();
  });

  return alphabet.join('');
}

function toNumbers(){
  let numArray = Array.from(new Array(10).keys());
  return numArray.join('');
}

function expandCharacters(inCharacters:string[]): string{
  const result : string[] = [];
  if(inCharacters.includes(ValidCharacters.Numeric)){
    result.push(toNumbers());
    inCharacters.splice(inCharacters.indexOf(ValidCharacters.Numeric), 1);
  }
  if(inCharacters.includes(ValidCharacters.Alpha)){
    result.push(toAlpha());
    result.push(ValidCharacters.Space);
    result.push(ValidCharacters.Hyphen)
    inCharacters.splice(inCharacters.indexOf(ValidCharacters.Alpha), 1);
  }
  if(inCharacters.includes(ValidCharacters.TextField)){
    result.push(toAlpha());
    result.push(toNumbers());
    result.push(ValidCharacters.Space);
    result.push(ValidCharacters.Hyphen)
    inCharacters.splice(inCharacters.indexOf(ValidCharacters.TextField), 1);
  }
  
  result.push(inCharacters.join(''));
  return result.join('');
}


export function validateCharacters(event: any, ...characters:string[]) {  
  let expandedChars = expandCharacters(characters);
  const inputValue = event.target.value;
  const lastChar = inputValue.substr(inputValue.length - 1);
  const allowedChars = expandedChars;
  if (!allowedChars.includes(lastChar)){
    event.target.value = inputValue.replaceAll(lastChar, '');
  }
}

export function validateInt(event: any, ...characters: string[]){
  let expandedChars = expandCharacters(characters);
  const inputValue = event.target.value;
  const lastChar = inputValue.substr(inputValue.length - 1);
  const allowedChars = expandedChars;
  if (!allowedChars.includes(lastChar)){
    event.target.value = Number.parseInt(inputValue.replaceAll(lastChar, ''),10);
  }
}

export function validateCharactersLength(event: any, allowedLenght: number) {  
  const inputValue = event.target.value;
  if (inputValue.length > allowedLenght){
    event.target.value = inputValue.substring(0,allowedLenght);
  }
} 

/**
  RFC 2822 standard email validation
  Regular Expression Pattern (Ref: https://bit.ly/33cv2vn):
*/
export function isEmailValid(inputEmail: any): boolean {
  const mailFormat = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
  return inputEmail.match(mailFormat);
}

export const ONEDAY = 86400000;
export const ONEYR = ONEDAY*364;
export const ONEHR = 60*60*1000;
export const ONEMIN = 60000;
export const ONESEC = 100;

type Order = 'asc' | 'desc';

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string },
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
export function stableSort<T>(array: any[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export const slopeConversion= (slope?: number)=>{
  if(typeof slope ==='undefined'){
    return ''
  }
  if(slope===1){
    return `${slope}: 0-25%`
  }
  else if(slope===2){
    return `${slope}: 26-45%`
  }
  else if(slope===3){
    return `${slope}: 41-45%`;
  }
  else if(slope===4){
    return `${slope}: 56-75%`;
  }
  else if(slope===5){
    return `${slope}: 76%+`;
  }
  else{
    return `${slope}%`
  }
};

export const posOfSlopeConversion=(pOfSlope?: number)=>{

  if(pOfSlope){
    switch (pOfSlope) {
      case 1:
        return "VALLEY BOTTOM OR FLAT";
      case 2:
        return "MIDSLOPE";
      case 3:
        return "RIDGE OR PEAK TOP";
    }
  }

};

export const ownerConversion=(owner?: number)=>{
  if(owner){
    switch (owner) {
      case 1:
        return "USDA FS";
      case 2:
        return "USDI BLM";
      case 3:
        return "USDI NPS";
      case 4:
        return "USDI BIA";
      case 5: 
        return "STATE";
      case 6: 
        return "LOCAL GOVT";
      case 7: 
        return "PVT/COMMRL";
      case 8: 
        return "OTH FEDERL";
      case 9:
        return "UNKNOWN";
      case 10:
        return "DOI-FWS";
      case 11:
        return "DOD";
      case 12:
        return "NOAA-NWS";
    }
  }

};

export const capitalizeFirstLetter=(string:string)=> {
  const stringLower = string.toLowerCase()
  return stringLower.charAt(0).toUpperCase() + stringLower.slice(1);
}
export function isValidDate(newValue: any){
  return ( (newValue instanceof Date) && !Number.isNaN(newValue.valueOf()));
}

export const truncateFourDecimals=(number: number)=>{
  return Math.floor(number*10000)/10000;
}

export const truncateTwoDecimals=(number: number)=>{
  return Math.floor(number*100)/100;
}

export const truncateOneDecimal=(number: number)=>{
  return Math.trunc(number*10)/10;
}

export const roundOneDecimal=(number:number)=>{
  if(number===null){
    return null
  }
  const rounded =Math.round(number*10)/10;
  const hasDecimal = number % 1 !== 0;
  if(!hasDecimal && number === rounded){
    
    return (rounded)
  }
  else{
    return rounded.toFixed(1);
  }
}

export const ConvertDMSToDD:any=(str: string)=>{
  if(str.charAt(0).includes('-')){
    const noNegativeForCalc = str.substring(1)
    const arrayStrVersion = noNegativeForCalc.split("-");
    const DD = Number(arrayStrVersion[0]) + (Number(arrayStrVersion[1])/60) + (Number(arrayStrVersion[2])/3600);  
    return(((-1*DD)).toString());
  }
  else{
    const arrayStrVersion = str.split("-");
    const DD = Number(arrayStrVersion[0]) + (Number(arrayStrVersion[1])/60) + (Number(arrayStrVersion[2])/3600);
    return ((DD)).toString();
  }
}

export const ConvertDDtoDMS=(decimal: any)=>{
  let sign =''

  const numDecimal= Number(decimal);
  if(numDecimal<0){
    sign='-'
  }
  const absolute = Math.abs(numDecimal)
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  let minutes = Math.floor(minutesNotTruncated);
  let seconds = (minutesNotTruncated - minutes) * 60;
  let degreeToReturn = degrees.toString();
  let minsToReturn = minutes.toString();
  let secsToReturn = seconds.toString();
  if(Math.abs(degrees) < 10 ){
    degreeToReturn = degrees.toString().padStart(2, '0');
  }
  if(Math.abs(degrees)<100 && Math.abs(degrees)>=10){
    minsToReturn = minutes.toString().padStart(1, '0');
  }
  if(Math.abs(seconds) < 10 ){
    secsToReturn = seconds.toString().padStart(1, '0');
  }
  return sign + degreeToReturn + "-"+ minsToReturn +"-"+secsToReturn;

};

export const RoundDecimal2 =(str:string)=>{
  return Number(str).toFixed(2);
};
export function titleCase(str:string) {
  let splitStr = str.toLowerCase().split(' ');
  for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
  }
  return splitStr.join(' '); 
};

export const errorResponse= (error: any, addAlert: any, message?:string, success?:boolean)=>{
  if(success){
    addAlert({
      id: '',
      message: message,
      type: 'informative',
      icon: 'fa-check'
    });
  }
  else {
    console.log('error', error)
    console.log('message', message)
    addAlert({
      id: '',
      message: message? message: alertMessages.retrievingStationData,
      type: 'error',
      icon: 'fa-exclamation-triangle'
    })
  } 
}

export const genUser = (user:any)=>{
  if(getAccessTokenCookie('accessToken') && (user.appRoles?.includes('FADM') || user.appRoles?.includes('FSAE') || user.appRoles?.includes('FSGE') || user.appRoles?.includes('FFSC') || user.appRoles?.includes('FGEN'))){
    return true
  }
  else{
    return false
  }
}


export const checkUserFieldSampleCollector = (user:any)=>{
    if(getAccessTokenCookie('accessToken') && (user.appRoles?.includes('FADM') || user.appRoles?.includes('FSAE') || user.appRoles?.includes('FSGE') || user.appRoles?.includes('FFSC'))){
      return true
    }
    else{
      return false
    }
}

export const checkAdminRole = (user: any)=>{
  if(getAccessTokenCookie('accessToken') && user?.appRoles?.includes('FADM')){
    return true
  }
  else{
    return false
  }
}

export const checkAPIUser = (user: any)=>{
  if(getAccessTokenCookie('accessToken') && user.appRoles?.includes('FAPI')){
    return true
  }
  else{
    return false
  }
}

export const fieldSampleAdminOrTester = (user: any)=>{
  if(getAccessTokenCookie('accessToken') && (user.appRoles?.includes('FADM')|| user.appRoles?.includes('FTST'))) {
    return true
  }
  else{
    return false
  }
};


export const fieldSampleAreaEditor = (user: any)=>{
  if(getAccessTokenCookie('accessToken') && (user.appRoles?.includes('FADM')|| user.appRoles?.includes('FSAE'))) {
    return true
  }
  else{
    return false
  }
};
export const fieldSampleGroupEditor = (user: any)=>{
  if(getAccessTokenCookie('accessToken') && (user.appRoles?.includes('FADM')|| user.appRoles?.includes('FSAE')|| user.appRoles?.includes('FSGE'))){
    return true
  }
  else{
    return false
  }
};
export const preventMinus = (e) => {
  if (e.code === 'Minus' || e.key === "-") {
      e.preventDefault();
  }
};


export const unavailableTooltipMsg = (msgFragment : string) => {
    return msgFragment + " is unavailable at this time.";
}


export const isValidPhoneNumber = (inPhoneValue: any): boolean => {
  const phoneFormat = /^\d{10}$/; // Only 10 digits number
  return Boolean(inPhoneValue.match(phoneFormat));
}  

export function removeNonNumerics(value:string){
  return value.replaceAll(/[^\d]/g, ''); // Remove non-numeric characters
}


export function formatPhoneNumber(input:any) {
  if(input){
    let phoneNumber = removeNonNumerics(input?.toString());
    phoneNumber = phoneNumber.slice(0,10); //only allow 10 digits
    if(phoneNumber.length<=3){
      return phoneNumber
    }
    else if(phoneNumber.length<=6){
      return `${phoneNumber.slice(0,3)}-${phoneNumber.slice(3)}`
    }
    else{
      return `${phoneNumber.slice(0,3)}-${phoneNumber.slice(3,6)}-${phoneNumber.slice(6,10)}`
    }
  }

};

export const combineStationObservationResponses = (stations: any[], observations:any[], type: string, endDate: any, fuelModel?:string)=>{
  const mappedStations = stations.map(station =>{
    const obs = observations.find(o => o.station_id===station.station_id);
    if(obs){
      return {...station, ...obs}
    }
    else{
      if(type === 'hourlyWeather'){
        return {
          ...station, 
          temperature: null,
          hourly_precip: null, 
          relative_humidity: null, 
          wind_speed: null, 
          wind_direction: null, 
          peak_gust_speed: null, 
          peak_gust_dir:null, 
          sol_rad: null, 
          snow_flag: null, 
          observation_type: moment().isBefore(moment(endDate))? 'F': "O",
          vapor_press_def: null
        }
      }
      else if(type ==='dailyWeather'){
        return {
          ...station, 
          temperature_min: null,
          temperature_max: null, 
          relative_humidity_min: null, 
          relative_humidity_max: null, 
          wind_speed_min: null, 
          wind_speed_max: null, 
          peak_gust_speed_min:null, 
          peak_gust_speed_max: null, 
          peak_wind_gust_direction: null, 
          peak_wind_gust_time: null,
          solar_radiation_max: null,
          daily_precipitation_total: null,
          snow_flag: null,
          observation_type: moment().isBefore(moment(endDate))? 'F': "O",
          vapor_press_def_min: null,
          vapor_press_def_max: null,
        }
      }
      else if(type==='dailyNfdr' && fuelModel){
        return{
          ...station,
          nfdr_type: moment().isBefore(moment(endDate))? 'F': "O" ,
          fuel_model: fuelModel,
          one_hr_tl_fuel_moisture_min: null,
          ten_hr_tl_fuel_moisture_min: null,
          hun_hr_tl_fuel_moisture_min: null,
          thou_hr_tl_fuel_moisture_min: null,
          ignition_component_max: null,
          ignition_component_max_time: null,
          spread_component_max: null,
          spread_component_max_time: null,
          energy_release_component_max: null,
          energy_release_component_max_time: null,
          burning_index_max: null,
          burning_index_max_time: null,
          herbaceous_lfi_fuel_moisture: null,
          woody_lfi_fuel_moisture: null,
          gsi: null,
          kbdi: null,
        }

      }
      else if(type==='hourlyNfdr' && fuelModel){
        return{
          ...station,
          nfdr_type: moment().isBefore(moment(endDate))? 'F': "O" ,
          fuel_model: fuelModel,
          one_hr_tl_fuel_moisture: null,
          ten_hr_tl_fuel_moisture: null,
          hun_hr_tl_fuel_moisture: null,
          thou_hr_tl_fuel_moisture: null,
          ignition_component: null,
          spread_component: null,
          energy_release_component: null,
          burning_index: null,
          herbaceous_lfi_fuel_moisture: null,
          woody_lfi_fuel_moisture: null,
          gsi: null,
          kbdi: null
        }
      }
      else{
        return{
          ...station
        }
      }
    }
  })

  return mappedStations
}
